module.exports = __webpack_public_path__ + "fonts/Gilroy-ExtraBold.otf?01bee9655bf434da91a4f4f5eed32339";